<div class="min-h-screen bg-gray-50 dark:bg-slate-900 p-4 md:p-6">
  <div class="max-w-7xl mx-auto">
    <!-- En-tête avec bouton Saisie -->
    <div class="flex flex-wrap items-center justify-between gap-4 mb-6">
      <div>
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">
          Mes Services
        </h1>
        <p class="text-gray-600 dark:text-gray-400 mt-1">
          Consultez vos statistiques et historique de ventes
        </p>
      </div>

      <!-- Bouton Saisie Ventes principal -->
      <button
        (click)="goToSalesEntry()"
        class="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl shadow-lg dark:shadow-slate-900/50 hover:from-blue-700 hover:to-blue-800 transition-all transform hover:scale-105"
        >
        <span class="text-xl">✏️</span>
        <span class="font-semibold">Saisie Ventes</span>
      </button>
    </div>

    <!-- Message d'erreur -->
    @if (errorMessage && !isLoading) {
      <div
        class="mb-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-300 px-4 py-3 rounded-lg"
        >
        {{ errorMessage }}
      </div>
    }

    <!-- Section : Mes Services (cartes) -->
    <div class="bg-white dark:bg-slate-800 rounded-xl shadow-sm dark:shadow-slate-900/30 p-4 md:p-6 mb-6">
      <h2
        class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4 flex items-center gap-2"
        >
        <span>📋</span> Mes Services
      </h2>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        @for (service of services; track service) {
          <div
            (click)="selectService(service)"
            class="bg-gradient-to-br from-gray-50 to-gray-100 dark:from-slate-800 dark:to-slate-700 rounded-lg p-4 cursor-pointer border-2 transition-all hover:shadow-md dark:shadow-slate-900/50"
            [class.border-blue-500]="selectedService === service"
            [class.border-transparent]="selectedService !== service"
            >
            <div class="flex items-center justify-between mb-2">
              <h3 class="font-semibold text-gray-900 dark:text-white">
                {{ service.serviceName || service.name || service }}
              </h3>
              <span class="text-2xl">
                @switch (service.serviceName || service.name || service) {
                  @case ('Petit-déjeuner') {
                    <span>🥐</span>
                  }
                  @case ('Déjeuner') {
                    <span>🍽️</span>
                  }
                  @case ('Dîner') {
                    <span>🌙</span>
                  }
                  @case ('Goûter') {
                    <span>🍰</span>
                  }
                  @default {
                    <span>📋</span>
                  }
                }
              </span>
            </div>
            @if (service.startTime && service.endTime) {
              <div
                class="text-xs text-gray-500 dark:text-gray-400"
                >
                ⏰ {{ service.startTime }} - {{ service.endTime }}
              </div>
            }
            <button
              class="mt-3 w-full px-3 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition-colors"
              >
              Voir statistiques
            </button>
          </div>
        }
      </div>

      <!-- Message si aucun service -->
      @if (services.length === 0) {
        <div class="text-center py-8 text-gray-500 dark:text-gray-400">
          <div class="text-4xl mb-2">📭</div>
          <p>Aucun service configuré</p>
        </div>
      }
    </div>

    <!-- Section : Historique des Ventes avec Filtres -->
    <div class="bg-white dark:bg-slate-800 rounded-xl shadow-sm dark:shadow-slate-900/30">
      <!-- Header avec Filtres -->
      <div class="border-b border-gray-200 dark:border-slate-700 p-4">
        <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
          <h2
            class="text-lg font-semibold text-gray-800 dark:text-gray-100 flex items-center gap-2"
            >
            <span>📊</span> Historique des Ventes
            <span class="text-sm font-normal text-gray-500 dark:text-gray-400"
              >({{ filteredSalesHistory.length }} enregistrements)</span
              >
            </h2>

            <!-- Bouton réinitialiser -->
            <button
              (click)="resetFilters()"
              class="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 dark:text-gray-300 flex items-center gap-1"
              >
              <span>🔄</span> Réinitialiser
            </button>
          </div>

          <!-- Barre de filtres -->
          <div class="flex flex-wrap gap-3">
            <!-- Filtre par service -->
            <select
              [(ngModel)]="filterService"
              (change)="applyFilters()"
              class="px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              >
              <option value="">Tous les services</option>
              @for (service of services; track service) {
                <option
                  [value]="service.serviceName || service.name || service"
                  >
                  {{ service.serviceName || service.name || service }}
                </option>
              }
            </select>

            <!-- Filtre par date (de) -->
            <div class="flex items-center gap-2">
              <span class="text-sm text-gray-500 dark:text-gray-400">Du</span>
              <input
                type="date"
                [(ngModel)]="filterDateFrom"
                (change)="applyFilters()"
                class="px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <!-- Filtre par date (à) -->
              <div class="flex items-center gap-2">
                <span class="text-sm text-gray-500 dark:text-gray-400">Au</span>
                <input
                  type="date"
                  [(ngModel)]="filterDateTo"
                  (change)="applyFilters()"
                  class="px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>

                <!-- Filtre par statut -->
                <select
                  [(ngModel)]="filterStatus"
                  (change)="applyFilters()"
                  class="px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                  <option value="all">Tous les statuts</option>
                  <option value="validated">✅ Validées</option>
                  <option value="pending">⏳ En attente</option>
                </select>
              </div>
            </div>

            <!-- Alerte : Dates sans saisie -->
            @if (missingDates.length > 0) {
              <div
                class="mx-4 mt-4 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg"
                >
                <div class="flex items-center gap-2 text-amber-800 dark:text-amber-300 font-medium mb-2">
                  <span>⚠️</span>
                  <span>{{ missingDates.length }} jour(s) sans saisie</span>
                </div>
                <div class="flex flex-wrap gap-2">
                  @for (date of missingDates.slice(0, 7); track date) {
                    <button
                      (click)="goToSalesEntryForDate(date)"
                      class="px-3 py-1 bg-amber-100 dark:bg-amber-900/30 hover:bg-amber-200 text-amber-800 dark:text-amber-300 text-sm rounded-full transition-colors"
                      >
                      {{ formatDate(date) }}
                    </button>
                  }
                  @if (missingDates.length > 7) {
                    <span
                      class="text-sm text-amber-600 self-center"
                      >
                      +{{ missingDates.length - 7 }} autres...
                    </span>
                  }
                </div>
              </div>
            }

            <!-- Liste des ventes avec scroll -->
            <div class="p-4 max-h-[400px] overflow-y-auto">
              <!-- Loading -->
              @if (isLoadingHistory) {
                <div class="text-center py-8">
                  <div
                    class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"
                  ></div>
                  <p class="mt-2 text-gray-500 dark:text-gray-400 text-sm">Chargement...</p>
                </div>
              }

              <!-- Liste vide -->
              @if (!isLoadingHistory && filteredSalesHistory.length === 0) {
                <div
                  class="text-center py-8 text-gray-500 dark:text-gray-400"
                  >
                  <div class="text-4xl mb-2">📭</div>
                  <p>Aucune vente trouvée pour ces critères</p>
                </div>
              }

              <!-- Liste des ventes -->
              @if (!isLoadingHistory && filteredSalesHistory.length > 0) {
                <div
                  class="space-y-2"
                  >
                  @for (sale of filteredSalesHistory; track sale) {
                    <div
                      (click)="openSaleDetail(sale)"
                      class="flex flex-wrap items-center justify-between gap-2 p-3 bg-gray-50 dark:bg-slate-900 hover:bg-blue-50 dark:bg-blue-900/20 rounded-lg cursor-pointer transition-colors border border-transparent hover:border-blue-200 dark:border-blue-800"
                      >
                      <!-- Gauche: Service + Date -->
                      <div class="flex items-center gap-3 min-w-[150px]">
                        <span class="text-xl">
                          @switch (sale.serviceName) {
                            @case ('Petit-déjeuner') {
                              <span>🥐</span>
                            }
                            @case ('Déjeuner') {
                              <span>🍽️</span>
                            }
                            @case ('Dîner') {
                              <span>🌙</span>
                            }
                            @case ('Goûter') {
                              <span>🍰</span>
                            }
                            @default {
                              <span>📋</span>
                            }
                          }
                        </span>
                        <div>
                          <div class="font-medium text-gray-900 dark:text-white">
                            {{ sale.serviceName }}
                          </div>
                          <div class="text-xs text-gray-500 dark:text-gray-400">
                            {{ formatDate(sale.saleDate) }}
                          </div>
                        </div>
                      </div>
                      <!-- Centre: Badges récapitulatifs -->
                      <div class="flex flex-wrap items-center gap-2">
                        <!-- Badge produits -->
                        <span
                          class="px-2 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 text-xs rounded-full whitespace-nowrap"
                          >
                          📦 {{ sale.productCount }} produits
                        </span>
                        <!-- Badge vendu -->
                        <span
                          class="px-2 py-0.5 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 text-xs rounded-full whitespace-nowrap"
                          >
                          ✅ {{ sale.totalSold }} vendus
                        </span>
                        <!-- Badge gaspillage (si > 0) -->
                        @if (sale.hasWaste) {
                          <span
                            class="px-2 py-0.5 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 text-xs rounded-full whitespace-nowrap"
                            >
                            🗑️ {{ sale.totalWaste | number: "1.0-0" }}€ perte
                          </span>
                        }
                        <!-- Badge ruptures (si > 0) -->
                        @if (sale.hasRuptures) {
                          <span
                            class="px-2 py-0.5 bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300 text-xs rounded-full whitespace-nowrap"
                            >
                            ⚠️ {{ sale.ruptureCount }} ruptures
                          </span>
                        }
                        <!-- Badge précision -->
                        @if (sale.accuracy > 0) {
                          <span
                            class="px-2 py-0.5 text-xs rounded-full whitespace-nowrap"
                            [class.bg-green-100]="sale.accuracy >= 80"
                            [class.text-green-700]="sale.accuracy >= 80"
                [class.bg-yellow-100]="
                  sale.accuracy >= 50 && sale.accuracy < 80
                "
                [class.text-yellow-700]="
                  sale.accuracy >= 50 && sale.accuracy < 80
                "
                            [class.bg-red-100]="sale.accuracy < 50"
                            [class.text-red-700]="sale.accuracy < 50"
                            >
                            🎯 {{ sale.accuracy }}%
                          </span>
                        }
                      </div>
                      <!-- Droite: Statut + CA + Action -->
                      <div class="flex items-center gap-3">
                        <!-- Statut -->
                        <span
                          class="px-2 py-1 text-xs rounded-full whitespace-nowrap"
                          [class.bg-green-100]="sale.isValidated"
                          [class.text-green-700]="sale.isValidated"
                          [class.bg-amber-100]="!sale.isValidated && sale.isDraft"
                          [class.text-amber-700]="!sale.isValidated && sale.isDraft"
                          [class.bg-gray-100]="!sale.isValidated && !sale.isDraft"
                          [class.text-gray-700]="!sale.isValidated && !sale.isDraft"
                          >
                          {{
                          sale.isValidated
                          ? "✅ Validée"
                          : sale.isDraft
                          ? "📝 Brouillon"
                          : "⏳ En attente"
                          }}
                        </span>
                        <!-- Montant CA -->
                        <div class="text-right min-w-[70px]">
                          <div class="font-bold text-green-600 dark:text-green-400">
                            {{ sale.totalRevenue | number: "1.0-0" }} €
                          </div>
                        </div>
                        <!-- Bouton action -->
                        <button
                          class="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-xs rounded-lg transition-colors whitespace-nowrap"
                          (click)="openSaleDetail(sale); $event.stopPropagation()"
                          >
                          Modifier
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>

          <!-- Panneau de statistiques -->
          @if (selectedService && serviceStats) {
            <div
              class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
              (click)="closeStats()"
              >
              <div
                class="bg-white dark:bg-slate-800 rounded-lg shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
                (click)="$event.stopPropagation()"
                >
                <!-- En-tête du panneau -->
                <div
                  class="sticky top-0 bg-white dark:bg-slate-800 border-b border-gray-200 dark:border-slate-700 px-6 py-4 flex items-center justify-between"
                  >
                  <h2 class="text-2xl font-bold text-gray-900 dark:text-white">
                    Statistiques - {{ serviceStats.serviceName }}
                  </h2>
                  <button
                    (click)="closeStats()"
                    class="text-gray-400 hover:text-gray-600 dark:text-gray-400 text-2xl"
                    >
                    ×
                  </button>
                </div>
                <!-- Loading -->
                @if (isLoading) {
                  <div class="p-8 text-center">
                    <div
                      class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"
                    ></div>
                    <p class="mt-4 text-gray-600 dark:text-gray-400">Chargement des statistiques...</p>
                  </div>
                }
                <!-- Contenu des stats -->
                @if (!isLoading && serviceStats) {
                  <div class="p-6">
                    <!-- Période -->
                    <div class="mb-6 text-center text-gray-600 dark:text-gray-400">
                      <p class="text-sm">Statistiques des 30 derniers jours</p>
                      @if (serviceStats.lastSaleDate) {
                        <p class="text-xs text-gray-500 dark:text-gray-400">
                          Dernière vente :
                          {{ serviceStats.lastSaleDate | date: "dd/MM/yyyy" }}
                        </p>
                      }
                    </div>
                    <!-- Métriques clés -->
                    <div class="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
                      <!-- Nombre de ventes -->
                      <div class="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 text-center">
                        <div class="text-3xl font-bold text-blue-600 dark:text-blue-400">
                          {{ serviceStats.salesCount }}
                        </div>
                        <div class="text-sm text-gray-600 dark:text-gray-400 mt-1">Ventes enregistrées</div>
                      </div>
                      <!-- Revenu total -->
                      <div class="bg-green-50 dark:bg-green-900/20 rounded-lg p-4 text-center">
                        <div class="text-3xl font-bold text-green-600 dark:text-green-400">
                          {{ serviceStats.totalRevenue | number: "1.0-0" }} €
                        </div>
                        <div class="text-sm text-gray-600 dark:text-gray-400 mt-1">Chiffre d'affaires</div>
                      </div>
                      <!-- Gaspillage -->
                      <div class="bg-red-50 dark:bg-red-900/20 rounded-lg p-4 text-center">
                        <div class="text-3xl font-bold text-red-600 dark:text-red-400">
                          {{ serviceStats.totalWaste | number: "1.0-0" }} €
                        </div>
                        <div class="text-sm text-gray-600 dark:text-gray-400 mt-1">Gaspillage total</div>
                      </div>
                      <!-- Précision moyenne -->
                      <div class="bg-purple-50 dark:bg-purple-900/20 rounded-lg p-4 text-center">
                        <div class="text-3xl font-bold text-purple-600">
                          {{ serviceStats.averageAccuracy }}%
                        </div>
                        <div class="text-sm text-gray-600 dark:text-gray-400 mt-1">Précision moyenne</div>
                      </div>
                      <!-- Ruptures -->
                      <div class="bg-orange-50 dark:bg-orange-900/20 rounded-lg p-4 text-center">
                        <div class="text-3xl font-bold text-orange-600">
                          {{ serviceStats.totalRuptures }}
                        </div>
                        <div class="text-sm text-gray-600 dark:text-gray-400 mt-1">Ruptures de stock</div>
                      </div>
                      <!-- Revenu moyen par vente -->
                      <div class="bg-indigo-50 dark:bg-indigo-900/20 rounded-lg p-4 text-center">
                        <div class="text-3xl font-bold text-indigo-600">
                          {{
                          serviceStats.salesCount > 0
                          ? (serviceStats.totalRevenue / serviceStats.salesCount
                          | number: "1.0-0")
                          : 0
                          }}
                          €
                        </div>
                        <div class="text-sm text-gray-600 dark:text-gray-400 mt-1">CA moyen / vente</div>
                      </div>
                    </div>
                    <!-- Taux de gaspillage -->
                    <div class="mb-6 bg-gray-50 dark:bg-slate-900 rounded-lg p-4">
                      <h3 class="font-semibold text-gray-700 dark:text-gray-300 mb-2">Taux de gaspillage</h3>
                      <div class="flex items-center">
                        <div class="flex-1 bg-gray-200 dark:bg-slate-700 rounded-full h-4 mr-4">
                          <div
                            class="h-4 rounded-full transition-all"
                  [class.bg-green-500]="
                    (serviceStats.totalWaste /
                      (serviceStats.totalRevenue + serviceStats.totalWaste)) *
                      100 <
                    10
                  "
                  [class.bg-yellow-500]="
                    (serviceStats.totalWaste /
                      (serviceStats.totalRevenue + serviceStats.totalWaste)) *
                      100 >=
                      10 &&
                    (serviceStats.totalWaste /
                      (serviceStats.totalRevenue + serviceStats.totalWaste)) *
                      100 <
                      20
                  "
                  [class.bg-red-500]="
                    (serviceStats.totalWaste /
                      (serviceStats.totalRevenue + serviceStats.totalWaste)) *
                      100 >=
                    20
                  "
                  [style.width.%]="
                    (serviceStats.totalWaste /
                      (serviceStats.totalRevenue + serviceStats.totalWaste)) *
                    100
                  "
                          ></div>
                        </div>
                        <span class="font-bold text-gray-700 dark:text-gray-300">
                          {{
                          ((serviceStats.totalWaste /
                          (serviceStats.totalRevenue + serviceStats.totalWaste)) *
                          100 | number: "1.1-1") || 0
                          }}%
                        </span>
                      </div>
                    </div>
                    <!-- Actions -->
                    <div class="flex gap-4">
                      <button
                        (click)="closeStats()"
                        class="flex-1 px-6 py-3 bg-gray-200 dark:bg-slate-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-slate-600 transition-colors"
                        >
                        Fermer
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
